<template>
    <div class="wlx-partner-manager-wrapper">
        <div class="add-partner-enterprise-head clearfix">
            <div class="top-page-top fl">
                <span class="sp-top-text">合作企业</span>
            </div>
            <div class="fr btn-right">
                <el-button size="small" type="primary" class="add-par-enter-btn" @click="addCerfityData" icon="el-icon-circle-plus-outline">添加</el-button>
            </div>
        </div>
        <div class="cerfity-form-content">
            <el-table :data="partnerList" style="width: 100%">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="title" label="公司名称" width="300"></el-table-column>
                
                <el-table-column prop="cover" label="公司logo" width="200">
                    <template slot-scope="scope">
                        <el-popover v-if="scope.row.cover !=''"
                            placement="right"
                            width="400"
                            trigger="hover">
                            <img :src="scope.row.cover" style="width: 400px;"/>
                            <img :src="scope.row.cover" style="width: 100px;" slot="reference"/>
                            </el-popover>
                        <span v-else>暂无照片</span>
                        <!-- <div class="cerfity-img-con">
                            <img :src="scope.row.cover" alt />
                        </div> -->
                    </template>
                </el-table-column>
                <el-table-column prop="link" label="链接" width></el-table-column>
                <el-table-column prop="orderNumber" label="排序" width></el-table-column>
                <el-table-column prop="dateCreated" label="创建时间" width="200"></el-table-column>
                <el-table-column label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <el-button type="primary" class="el-icon-edit" @click="editCerfity(scope.row.Id, scope.row.title, scope.row.cover, scope.row.link,scope.row.orderNumber)" size="small"></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <el-button type="danger" class="el-icon-delete" @click="deleteCerfity(scope.row.Id)" size="small"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="partner-page-content">
                <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="pageIndex" :page-sizes="[10, 25, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-show="total > 0"></el-pagination>
            </div>
        </div>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="50%" :append-to-body="true">
            <div>
                <el-form :model="ruleForm" :rules="rules2" ref="ruleForm" label-width="100px" class="demo-ruleForm" :close-on-click-modal="false">
                    <el-form-item label="公司名称" prop="title">
                        <el-input v-model="ruleForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="logo">
                        <imageUpload :url="urlAliyunOSS" :files.sync="AvatorUrl" format="image"  v-if="dialogVisible"></imageUpload>
                    </el-form-item>
                    <el-form-item label="链接" prop="link">
                        <el-input v-model="ruleForm.link"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="link">
                        <el-input-number v-model="ruleForm.orderNumber"></el-input-number>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelForm('ruleForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import imageUpload from "components/uploadPartner.vue";
export default {
    data() {
        return {
            ruleForm: {
                title: "",
                content: "",
                link: "",
                orderNumber:0
            },
            AvatorUrl: "",
            rules: {
                title: [{ required: true, message: "请输入标题", trigger: "blur" }],
                content: [{ required: true, message: "请输入序号", trigger: "blur" }],
            },
            rules2: {
                title: [{ required: true, message: "请输入名称", trigger: "blur" }],
                link: [{ required: true, message: "请输入链接", trigger: "blur" }],
            },
            urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
            partnerList: [],
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            dialogVisible: false,
            logoUrl: "",
            defaultCerfityImg: require("assets/images/bg4.png"),
            cerfityId: "",
            dialogTitle: "",
        };
    },
    components: {
        imageUpload,
    },
    watch: {
        AvatorUrl: function(val) {
            this.logoUrl = val;
            console.log(val);
        },
    },
    created() {
        this.getPartnerList(1);
    },
    methods: {
        getPartnerList(page) {
            let that = this;
            this.$http
                .post("/api/XOrg/AssociationPartnerManager/getPartnerList", {
                    page: page,
                    pageSize: this.pageSize,
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.partnerList = rst.list;
                        that.total = rst.pagination.totalCount;
                        that.pageSize = rst.pagination.pageSize;
                        that.pageIndex = rst.pagination.pageIndex;
                    }
                });
        },
        onPageChangeHandler(page) {
            this.getPartnerList(page);
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getPartnerList(1);
        },
        submitForm(formName) {
            let that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (that.cerfityId == "") {
                        that.addPartner();
                    } else {
                        that.editPartner();
                    }
                } else {
                    return false;
                }
            });
        },
        addPartner() {
            var that = this;
            this.$http
                .post("/api/XOrg/AssociationPartnerManager/addPartner", {
                    title: this.ruleForm.title,
                    cover: this.AvatorUrl,
                    link: this.ruleForm.link,
                    orderNumber: this.ruleForm.orderNumber
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.getPartnerList(1);
                        that.dialogVisible = false;
                        that.$message({
                            type: "info",
                            message: rst.msg,
                        });
                    } else {
                        that.$message({
                            type: "info",
                            message: rst.msg,
                        });
                    }
                });
        },
        editPartner() {
            var that = this;
            this.$http
                .post("/api/XOrg/AssociationPartnerManager/editPartner", {
                    partnerId: this.cerfityId,
                    title: this.ruleForm.title,
                    cover: this.AvatorUrl,
                    link: this.ruleForm.link,
                    orderNumber: this.ruleForm.orderNumber
                })
                .then(function(rst) {
                    if (rst.code > 0) {
                        that.getPartnerList(that.pageIndex);
                        that.dialogVisible = false;
                        that.$message({
                            type: "info",
                            message: rst.msg,
                        });
                    } else {
                        that.$message({
                            type: "info",
                            message: rst.msg,
                        });
                    }
                });
        },
        cancelForm(formName) {
            this.$refs[formName].resetFields();
            this.AvatorUrl = "";
            this.dialogVisible = false;
        },
        addCerfityData() {
            this.dialogTitle = "新增合作企业";
            this.AvatorUrl = "";
            this.cerfityId = "";
            this.ruleForm.title = "";
            this.ruleForm.link = "";
            this.ruleForm.orderNumber = 0;
            this.dialogVisible = true;
        },
        editCerfity(id, title, cover, link,orderNumber) {
            this.dialogTitle = "编辑合作企业";
            this.cerfityId = id;
            this.ruleForm.title = title;
            this.AvatorUrl = cover;
            this.ruleForm.link = link;
            this.ruleForm.orderNumber = orderNumber;
            this.dialogVisible = true;
        },
        deleteCerfity(id) {
            this.$confirm("此操作将删除该合作企业, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let that = this;
                    this.$http
                        .post("/api/XOrg/AssociationPartnerManager/deletePartner", {
                            partnerId: id,
                        })
                        .then((res) => {
                            if (res.code > 0) {
                                this.getPartnerList(1);
                                this.$message({
                                    type: "info",
                                    message: "删除成功",
                                });
                            } else {
                                this.$message({
                                    type: "info",
                                    message: res.msg,
                                });
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
    },
};
</script>
<style lang="scss">
.wlx-partner-manager-wrapper {
    background: #fff;
    padding-bottom: 20px;
    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top{
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead{
        color: #05243D;
    }
    .btn-right{
        margin-right: 30px;
        line-height: 60px;
    }
}
</style>
